/** @jsx jsx */
import React from "react";
import ReactModal from "react-modal";
import { Box, jsx } from "theme-ui";
import { css, Global } from "@emotion/react";
import Icon from "./Icon";

const defaultStyles = {
  content: {
    height: "90vh",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    padding: '0px',
    borderRadius: '5px 5px 0px 0px',
    border: "5px solid #272763",
    boxShadow: "0px 3px 6px #00000029",
    transform: "translate(-50%, -50%)",
    maxWidth:'95%'
  },
  overlay: {
    zIndex: 10000
  }
};

ReactModal.setAppElement("#___gatsby");

const Modal = ({ children, customStyles, closeModal, showModal }) => (
  <Box sx={{maxWidth:'95%'}}>

  <ReactModal
    isOpen={showModal}
    style={customStyles || defaultStyles}
    onRequestClose={closeModal}
    >
    {showModal &&
      <Global
      styles={css`
          html,
          body {
            overflow-y: hidden;
            padding-right: 7.5px;
          }
          `}
      />}
    <div
      onClick={closeModal}
      sx={{
        cursor: "pointer",
        fontSize: "2rem",
        fontWeight: 700,
        position: "absolute",
        top: "1rem",
        right: "1rem",
        color: "white",
        transition: "200ms",
        "&:hover": {
          color: "gray",
        },
      }}
    >
      <Icon
        icon='io-close'
      />
    </div>
    {children}
  </ReactModal>
      </Box>
);

export default Modal;
